namespace TR {

    ///NOTE: this is now deprecated, please use the validationMessage directive as that
    //is aligned with what we would like to do going forward with the look and feel and activation
    //or errors across the site.
    interface ValidationStatusAttributes extends ng.IAttributes {
        fieldNames: string;
        labelStrings: string;
        msgMap: string;
        rootForm: string;
        waitFor: string;
    }

    interface ValidationStatusElement extends Element {
        name :string;
    }

    interface ValidationStatusModel extends ng.INgModelController {
        ValidationSummary :{ PreviouslyFocused :boolean};
    }

    interface ValidationStatusScope extends ng.IScope {
        vs :ValidationStatus;
    }


    class FormField {
        private Field :ValidationStatusModel;
        private Children:ValidationStatusModel[] = [];

        constructor(field: ng.INgModelController) {
            this.Field = FormField.addValidationObjectToField(field);
        }

        public addChildField(field: ng.INgModelController) :void {
            this.Children.push(FormField.addValidationObjectToField(field));
        }

        public wasPreviouslyFocused() :boolean {
            return this.Children.length > 0 ?
                _.every(this.Children, (f) => f.ValidationSummary.PreviouslyFocused === true)
                : this.Field.ValidationSummary.PreviouslyFocused;
        }

        public isValid() :boolean {
            return !this.Field.$invalid;
        }

        public errorMessages() :{} {
            return this.isValid() ? {} : this.Field.$error;
        }

        private static addValidationObjectToField(field: ng.INgModelController) :ValidationStatusModel{
            let f = field as ValidationStatusModel;
            f.ValidationSummary = {
                PreviouslyFocused: false
            };
            return f;
        }
    }

    class ValidationStatus {

        private alwaysWatchFields :string;
        private fieldNames :string;
        private fields :FormField[] = [];
        private form :ng.IFormController;
        private readonly labels :string[] = [];
        private labelStrings :string;
        private readonly map :any;
        private msgMap :string | null;
        private rootForm :ng.IFormController;
        private watchers :{() :void}[] = [];

        public active :boolean;
        public invalid :boolean;
        public errorMessages :string[] = [];

        constructor(private $scope :ValidationStatusScope,
                    private analytics :any,
                    private broker :Core.Broker,
                    private validationService :any) {

            for (let l of this.labelStrings.split('|')) {
                this.labels.push(l);
            }

            this.map = this.msgMap == null ? {} : JSON.parse(this.msgMap);
        }

        init(form :ng.IFormController, formElement :JQuery) :void {

            this.form = form;

            for (let name of this.fieldNames.split('|')) {
                let field = this.form[name];
                if (!field) {
                    throw new Error(`There was no field named "${name}"`);
                }
                let formField = new FormField(field);

                //find the input DOM element within our form and attach some handlers
                //use the name property to associate the field and input
                const input = formElement.find(`[name='${name}']`).first();
                if (input.is('select') || input.is('input')) {
                    input
                        .focus(() => this.focusHandler())
                        .blur((e) => this.blurHandler(e));
                } else {
                    //find our actual sub inputs and add track these
                    _.each(input.find('select,input'), (ele :ValidationStatusElement) => {
                        const field = this.form[ele.name];
                        if (field) {
                            formField.addChildField(field);
                        }
                    });

                    input
                        .focusin(() => this.focusHandler())
                        .focusout((e) => this.blurHandler(e));
                }

                this.fields.push(formField);
            }

            //this is a bit of a hack to solve issues where we have external influences on a field.
            //we should avoid having so many watches
            if (this.alwaysWatch()) {
                _.each(this.fields, (f,i) => {
                    this.watchers.push(
                        this.$scope.$watch(`vs.fields[${i}].isValid()`, (n, o) => {
                            if (n !== o) {
                                this.active = _.every(this.fields, (f) => f.wasPreviouslyFocused() === true)
                                                            || _.every(this.fields, (f) => f.isValid() === true);
                                this.updateValidationStatus();
                            }
                        })
                    );
                });
            }

            this.$scope.$watch('vs.rootForm.$submitted', (v) => {
                if (v) {
                    this.active = true;
                    this.updateValidationStatus();
                }
            });
        }

        private blurHandler(e: JQueryEventObject) :void {
            if (this.watchers.length && !this.alwaysWatch()) {
                _.each(this.watchers, w => w());
                this.watchers = [];
            }

            //use the elements name to get the field from the form
            let field = this.form[(<ValidationStatusElement>e.target).name];
            field.ValidationSummary.PreviouslyFocused = true;

            this.$scope.$apply(() => {
                this.active = _.every(this.fields, (f) => f.wasPreviouslyFocused() === true)
                                || _.every(this.fields, (f) => f.isValid() === true);
                if (this.active) {
                    this.updateValidationStatus();
                }
            });
        }

        private focusHandler() :void {
            //if all the fields were previously active and we are invalid then watch our fields while we type
            //so that we know when we are valid
            if (_.every(this.fields, (f) => f.wasPreviouslyFocused() === true) && !this.alwaysWatch()) {
                _.each(this.fields, (f,i) => {
                    this.watchers.push(
                        this.$scope.$watch(`vs.fields[${i}].isValid()`, () => {
                                this.updateValidationStatus();
                            }, true
                        )
                    );
                });
            }
        }

        private updateValidationStatus() :void {
            let errors :string[] = [];

            _.transform(this.fields, (result, f, i :number) => {
                if (!f.isValid()) {
                    _.forOwn(f.errorMessages(), (v, k) =>
                        result.push(this.validationService.translateFieldLabel(this.labels[i], k, this.map))
                    );
                }
                return result;
            }, errors);

            this.invalid = errors.length > 0;
            this.errorMessages = _.uniq(errors);

            if (errors.length > 0 && this.active) {
                this.analytics.track('mixpanel', 'FormValidationInline', {InlineErrors : this.errorMessages.join(',')});
                this.broker.publish('validationErrors', this.errorMessages);
            }
        }

        private alwaysWatch() :boolean {
            return this.alwaysWatchFields === 'true';
        }
    }

    angular
        .module('TR')
        .directive('validationStatus', (): ng.IDirective => {
            return {
                require: '^form',
                restrict: 'E',
                replace: true,
                scope: {},
                template:
                        `<div class="validation-status-wrapper">
                            <div ng-class="{'auto-width': vs.cssAutoWidth === 'true'}">
                                <i class="status"
                                   ng-class="vs.invalid ? 'icon-close' : 'icon-check'"
                                   ng-show="vs.active">
                                </i>
                                <div class="content" ng-transclude></div>
                            </div>
                            <ul class="error-messages" ng-show="vs.active && vs.invalid">
                                <li ng-repeat="err in vs.errorMessages">
                                   {{err}}
                               </li>
                            </ul>
                        </div>`,
                transclude: true,
                bindToController: {
                    alwaysWatchFields: '@?',
                    cssAutoWidth: '@?',
                    fieldNames: '@',
                    labelStrings: '@',
                    msgMap: '@?',
                    rootForm: '=',
                    waitFor: '=?'
                },
                controller: ValidationStatus,
                controllerAs: 'vs',
                link: (scope :ValidationStatusScope,
                       el :ng.IAugmentedJQuery,
                       attr :ValidationStatusAttributes,
                       formCtrl :ng.IFormController) => {

                    //there is an assumption here that the input field we are validating has a name attribute that is a
                    //property on the form with the same value.
                    //Not great, but so the we can keep everything together this might be ok (maybe, sort of)

                    //we need our form DOM element so that we can find the inputs
                    //get the elements parent forms and the first one should be the one to use
                    const formEl = angular.element(el).closest('form,ng-form');

                    if (attr.waitFor) {
                        const watch = scope.$watch('vs.waitFor', (v) => {
                            if (v) {
                                scope.vs.init(formCtrl, formEl);
                                watch();
                            }
                          });
                    } else {
                        scope.vs.init(formCtrl, formEl);
                    }

                }
            };
        });
}
